import React, { Component } from "react";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import SalesDefaultLeftView from "./SalesDefaultLeftView";


@observer
class SalesCalendar extends Component {

    componentDidMount() {
        const { rootStore } = this.props;
        let today = new Date();
        this.loadYYMM(today);
        this.loadDate(today.getDate(), today.getDay());
    }

    getFirstDay = (yy, mm) => {
        return new Date(yy, mm, 1);
    }

    getLastDay = (yy, mm) => {
        return new Date(yy, mm + 1, 0);
    }

    addZero = (num) => {
        if (num < 10) {
            return '0' + num
        } else {
            return num
        }
    }

    init = (e) => {
        const { rootStore } = this.props;
        let today = new Date();
        let monForChange = new Date().getMonth();
        let activeDate = new Date();
        let nextMonth = function () {
            let d = this.activeDate;
            d.setMonth(d.getMonth() + 1);
            //document.querySelector('.slt_year [value="' + d.getFullYear() + '"]').selected = true;
            //document.querySelector('.slt_month [value="' + (d.getMonth() + 1) + '"]').selected = true;
            this.activeDate = d;
            loadYYMM(d);
        }
        let prevMonth = function () {
            let d = this.activeDate;
            d.setMonth(d.getMonth() - 1);
            //document.querySelector('.slt_year [value="' + d.getFullYear() + '"]').selected = true;
            //document.querySelector('.slt_month [value="' + (d.getMonth() + 1) + '"]').selected = true;
            this.activeDate = d;
            loadYYMM(d);
        }
        let changeSlt = function () {
            let changeDate = new Date();
            changeDate.setFullYear($sltYear.value);
            changeDate.setMonth($sltMonth.value - 1);
            this.monForChange = changeDate.getMonth();
            this.activeDate = changeDate;
            return changeDate;
        }

        let activeDTag = null
        let getIndex = function (node) {
            let index = 0;
            while (node = node.previousElementSibling) {
                index++;
            }
            return index;
        }

    }

    loadDate = (date, dayIn) => {
        const { rootStore } = this.props;
        document.getElementsByClassName("date").textContent = date;
        document.getElementsByClassName("day").textContent = rootStore.salesStore.getSalesCalSetting.dayList[dayIn];
    }

    formatDate = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(), year = d.getFullYear();
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        return [year, month, day].join('-');
    }

    loadYYMM = (fullDate) => {
        const { rootStore } = this.props;
        let yy = fullDate.getFullYear();
        let mm = fullDate.getMonth();
        let firstDay = this.getFirstDay(yy, mm);
        let lastDay = this.getLastDay(yy, mm);
        let today = new Date();
        let markToday;  // for marking today date

        if (mm === today.getMonth() && yy === today.getFullYear()) {
            markToday = today.getDate();
        }

        document.getElementsByClassName("month").textContent = rootStore.salesStore.getSalesCalSetting.monList[mm];
        document.getElementsByClassName("year").textContent = yy;
        let startDate = this.formatDate(firstDay);
        let endDate = this.formatDate(lastDay);

        let datas = rootStore.salesStore.getSalesCalendarList;
        let trtd = '';
        let startCount;
        let countDay = 0;
        let weekSum = [
            {
                payment: 0,
                count: 0
            },
            {
                payment: 0,
                count: 0
            },
            {
                payment: 0,
                count: 0
            },
            {
                payment: 0,
                count: 0
            },
            {
                payment: 0,
                count: 0
            },
            {
                payment: 0,
                count: 0
            },
            {
                payment: 0,
                count: 0
            },
            {
                payment: 0,
                count: 0
            }
        ]
        for (let i = 0; i < 7; i++) {
            if (startCount != 0) {
                trtd += '<tr>';
                var payment = 0;
                var count = 0;
                for (let j = 0; j < 8; j++) {
                    if (i === 0 && !startCount && j === firstDay.getDay()) {
                        startCount = 1;
                    }
                    if (!startCount) {
                        if (j === 0) {
                            trtd += '<td class="fst">'
                        } else if (j === 7) {
                            trtd += '<td class="lst">'
                        } else {
                            trtd += '<td>'
                        }
                    } else {
                        let fullDate = yy + '-' + this.addZero(mm + 1) + '-' + this.addZero(countDay + 1);
                        if (j === 0) {
                            trtd += '<td class="day fst'
                        } else if (j === 7) {
                            trtd += '<td class="day lst'
                        } else {
                            trtd += '<td class="day'
                        }

                        if (j === 7) {
                            //class명인거같음
                            trtd += ' data-date=total data-fdate=total1>';
                        } else {
                            trtd += (markToday && markToday === countDay + 1) ? ' today" ' : '"';
                            trtd += ' data-date=' + (countDay + 1) + ' data-fdate=' + fullDate + '>';
                        }
                    }
                    if (j != 7 && i != 7) {
                        trtd += (startCount) ? '<div class="inner"><span class="day">' : '';
                        trtd += (startCount) ? ++countDay : '';
                        trtd += (startCount) ? '</span>' : '';

                        let index = datas.findIndex(function (item, i) {
                            let dayI = item.sdate.substring(8, 11) * 1;
                            return (countDay) === dayI;
                        });
                        let countDayArray = datas[index];
                        if (countDayArray != undefined) {
                            let pay = countDayArray.orderSales;
                            trtd += (startCount) ? '<span class="pay">' + pay.toLocaleString() + '원</span><span class="num">' + countDayArray.orderCount + '건</span>' : '';
                            payment += pay;
                            count += countDayArray.orderCount
                            weekSum[j].payment += pay
                            weekSum[j].count += countDayArray.orderCount
                        }
                    } else {
                        weekSum[7].payment += payment
                        weekSum[7].count += count
                        trtd += '<div class="inner"><span class="day">' + payment + '</span><span class="num">' + count + '건</span>'
                    }
                    trtd += (startCount) ? '</div>' : '';
                    if (countDay === lastDay.getDate()) {
                        startCount = 0;
                    }
                    trtd += '</td>';
                }
                trtd += '</tr>';
            }
        }

        //요일별 합계 마지막줄
        let totalSum = 0;
        let totalCnt = 0;
        trtd += '<tr>';
        for (let j = 0; j < 8; j++) {
            totalSum += weekSum[j].payment
            totalCnt += weekSum[j].count
            if (j === 0) {
                trtd += '<td className="sum fst">'
                trtd += '<div className="inner"><span className="day">' + weekSum[j].payment + '</span><span className="num">' + weekSum[j].count + '건</span>'
            } else if (j === 7) {
                trtd += '<td class="sum lst">'
                trtd += '<div className="inner"><span className="day">' + totalSum + '</span><span className="num">' + totalCnt + '건</span>'
            } else {
                trtd += '<td class="sum">'
                trtd += '<div className="inner"><span className="day">' + weekSum[j].payment + '</span><span className="num">' + weekSum[j].count + '건</span>'
            }
            trtd += '</td>';
        }
        trtd += '</tr>';

        document.getElementById("tbl_cal_body").innerHTML += trtd;
    }

    render() {
        const { rootStore } = this.props;
        let salesStore = rootStore.salesStore;

        return (
            <>
                <div className="article_setting">
                    {/*왼쪽 메뉴 */}
                    <SalesDefaultLeftView rootStore={rootStore} />
                    <div className="section_content sales">
                        <div className="top">
                            <h3>매출 캘린더</h3>
                            <div className="sales close">
                                <Link to="/"><button type="button"><span className="btn_order_history_close">닫기</span></button></Link>
                            </div>
                        </div>
                        <div className="scroll">
                            {/* <div className="inner"> */}
                            <div className="section_calendar">
                                {/* <h2><strong className="tit_cal">매출 캘린더</strong><span className="bar"></span><em></em></h2> */}
                                <div className="wrap_calendar">
                                    <div className="box_control">
                                        <button type="button" className="btn_prev">이전달</button>
                                        <select className="slt_year">
                                            {/* <jsp:useBean id="now" className="java.util.Date" />
                        <fmt:formatDate value="${now}" pattern="yyyy" var="yearStart" />
                        <fmt:formatDate value="${now}" pattern="MM" var="monthStart" />
                        <!-- <c:forEach begin="0" end="10" var="result" step="1">
                            <option value="<c:out value=" ${yearStart - result}" />" class="lt">
                            <c:out value="${yearStart - result}" />년</option>
                        </c:forEach> -->
                        <c:out value="${yearStart - result}" />년</option> */}
                                        </select>
                                        <select className="slt_month">
                                            {/* <!-- <c:forEach begin="1" end="12" var="idx" step="1">
                            <option value="<c:out value=" ${idx}" />" class="lt" <c:if test="${idx == monthStart*1}">
                                selected="selected"</c:if>>${idx}월</option>
                        </c:forEach> --> */}
                                            <option value="">1월</option>
                                            <option value="">2월</option>
                                            <option value="">3월</option>
                                            <option value="">4월</option>
                                        </select>
                                        <span className="year"></span>
                                        <span className="month"></span>
                                        <span className="date"></span>
                                        <span className="day"></span>
                                        <button type="button" className="btn_next">다음달</button>
                                    </div>
                                    <table className="tbl_cal">
                                        <thead>
                                            <tr>
                                                <th className="fst">일요일</th>
                                                <th>월요일</th>
                                                <th>화요일</th>
                                                <th>수요일</th>
                                                <th>목요일</th>
                                                <th>금요일</th>
                                                <th>토요일</th>
                                                <th className="lst">합계</th>
                                            </tr>
                                        </thead>
                                        <tbody id="tbl_cal_body">
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sales close">
                        <Link to="/"><button type="button"><span className="btn_order_history_close">닫기</span></button></Link>
                    </div>


                    {/* </div > */}
                </div >
            </>
        )
    }
}

export default SalesCalendar;